import type { CodexThread, ThreadItem, ThreadStatus } from "./types";

export type StatusKind = "waiting" | "running" | "done" | "error" | "idle";

export function statusKind(status: ThreadStatus): StatusKind {
  if (status.type === "systemError") return "error";
  if (status.type === "active") {
    if (status.activeFlags.includes("waitingForFailover") || status.activeFlags.includes("waitingInQueue") || status.activeFlags.includes("waitingOnApproval") || status.activeFlags.includes("waitingOnUserInput")) {
      return "waiting";
    }
    return "running";
  }
  return status.type === "idle" ? "done" : "idle";
}

export function statusLabel(status: ThreadStatus): string {
  if (status.type === "active" && status.activeFlags.includes("recoveringOnServer")) return "服务器恢复中";
  if (status.type === "active" && status.activeFlags.includes("waitingForFailover")) return "等待接管";
  if (status.type === "active" && status.activeFlags.includes("waitingInQueue")) return "排队中";
  const labels: Record<StatusKind, string> = {
    waiting: "待处理",
    running: "运行中",
    done: "已结束",
    error: "异常",
    idle: "未载入",
  };
  return labels[statusKind(status)];
}

export function threadTitle(thread: CodexThread): string {
  return thread.name?.trim() || thread.preview?.trim() || "未命名任务";
}

export function shortPath(value: string): string {
  const parts = value.split("/").filter(Boolean);
  return parts.length > 2 ? `…/${parts.slice(-2).join("/")}` : value || "-";
}

export function relativeTime(timestamp: number): string {
  const milliseconds = timestamp < 1_000_000_000_000 ? timestamp * 1000 : timestamp;
  const delta = Math.max(0, Date.now() - milliseconds);
  const minutes = Math.floor(delta / 60_000);
  if (minutes < 1) return "刚刚";
  if (minutes < 60) return `${minutes} 分钟前`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} 小时前`;
  return `${Math.floor(hours / 24)} 天前`;
}

export function itemText(item: ThreadItem): string {
  if (item.type === "userMessage") {
    return item.content?.filter((part) => part.type === "text").map((part) => part.text ?? "").join("\n") ?? "";
  }
  if (item.text) return item.text;
  if (item.type === "reasoning") return item.summary?.join("\n") ?? "";
  return "";
}
